import { useEffect } from 'react';
import { usePricingData, BUYABLE_FEE_POLICY } from '@fiverr-private/price_upfront_sdk';
import { raiseToast } from '@fiverr-private/toast';
import { logger } from '@fiverr-private/obs';
import { useIsClient } from '@fiverr-private/hooks';
import { useAppContext } from '../../../../components/context/listingsContext';
import { STORAGE_KEY_SUFFIX, MAX_DISPLAY_COUNT, feePolicyMessages } from '../PricingProviderWithToast.constants';
import { appTranslate } from '../../../../../../page/i18n';

export const usePriceToast = (): void => {
    const isClient = useIsClient();
    const { flow } = useAppContext();
    const { isPriceUpfrontEnabled, priceUpfrontBuyableFeePolicy } = usePricingData();

    useEffect(() => {
        if (!isClient || !isPriceUpfrontEnabled || !flow || !priceUpfrontBuyableFeePolicy) {
            return;
        }

        if (priceUpfrontBuyableFeePolicy === BUYABLE_FEE_POLICY.NONE) return;

        const storageKey = `${flow}${STORAGE_KEY_SUFFIX}`;

        try {
            const storedValue = localStorage.getItem(storageKey);
            const counter = storedValue ? parseInt(storedValue, 10) : 0;

            if (counter < MAX_DISPLAY_COUNT) {
                const messageKey = feePolicyMessages[priceUpfrontBuyableFeePolicy];
                raiseToast({
                    type: 'info',
                    location: 'bottom',
                    duration: 10000,
                    message: appTranslate(messageKey),
                });

                const newCounter = counter + 1;
                localStorage.setItem(storageKey, newCounter.toString());
            }
        } catch (error: unknown) {
            logger.error('Failed to access localStorage for price badge', error as Error);
        }
    }, [flow, isClient, isPriceUpfrontEnabled, priceUpfrontBuyableFeePolicy]);
};
